import {React, useState, useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import axios from 'axios';
import {Edit, Delete} from '@mui/icons-material';
import LeaveMasterForm from '../forms/LeaveMasterForm';
import Popup from '../Popup';
import Notification from '../Notification';
import ConfirmDialog from '../ConfirmDialog';
import { useDispatch, useSelector } from 'react-redux';
import { updateTableActions } from '../../store/update-table-slice';
import { formatDate } from '../../common/constants';

let fetch_id = 0;
let delete_id = 0;
export default function LeaveTypesTable() {
  const [openPopup, setOpenPopup] = useState(false);
  const [leaveTypes, setLeaveTypes] = useState([]);
  const [notify, setNotify] = useState({isOpen: false, message: '', type: ''});
  const [confirmDialog, setConfirmDialog] = useState({isOpen: false, title: '', subTitle: ''});
  const navigate = useNavigate();
  const UPDATE_LEAVE_MASTER = useSelector(state => state.updateTable.updateLeaveMaster);
  const dispatch = useDispatch();

  async function getAllLeaveTypes(){
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/company-master/leave-master/view`);
      if(response.status === 200) {
        setLeaveTypes(response.data);
      }
      
    } catch (e) {
      if(e.response.status === 401) {
        setNotify({
          isOpen: true,
          message: 'Session Expired!',
          type: 'error'
        });
        setTimeout(() => {
          navigate('/');
        },1000);
      }
    }
  }

  useEffect(()=>{
    getAllLeaveTypes();
  }, []);

  useEffect(()=>{
    if(UPDATE_LEAVE_MASTER === true) {
      getAllLeaveTypes();
      dispatch(updateTableActions.stopUpdateLeaveMaster());
    }
  }, [UPDATE_LEAVE_MASTER]);

  const handleDelete = async (delete_id) => {
      setConfirmDialog({
        ...confirmDialog,
        isOpen: false
      });
      try {
        const res = await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/company-master/leave-master/delete-leave/` + delete_id);
        if(res.status === 200) {
          getAllLeaveTypes();
          setNotify({
            isOpen: true,
            message: 'Successfully Deleted!',
            type: 'error'
        });
        dispatch(updateTableActions.startUpdateLeaveMaster);
        }
      } catch (e) {
        if(e.response.status === 401) {
          setNotify({
            isOpen: true,
            message: 'Session Expired!',
            type: 'error'
          });
          setTimeout(() => {
            navigate('/');
          },1000);
        }
      }
  }

  return (
    <div>
    <table class="table">
        <thead class="table-dark">
          <tr>
            <th class="table-dark"></th>
            <th class="table-dark"></th>
            <th scope="col">Leave Type</th>
            <th scope="col">Entitled Days</th>
            <th scope="col">Max Occasions</th>
            <th scope="col">Max Days</th>
            <th scope="col">Paid/Unpaid</th>
            <th scope="col">Prefix Suffix</th>
            <th scope="col">Entitled Days Duration</th>
            <th scope="col">Cary Forward</th>
            <th scope="col">Leave Year From</th>
            <th scope="col">Leave Year To</th>
            <th scope="col">Company ID</th>
            <th scope="col">Leave Encashable</th>
            <th scope="col">Encash Based On</th>

          </tr>
        </thead>
        <tbody>
          {leaveTypes.map((leaveType , i) => {
            return (
              <>
                <tr>
                  <td><button type="button" class="btn btn-outline-primary btn-sm" onClick={() => {setOpenPopup(true); fetch_id=leaveType.leave_type_id;}} > <Edit/> Edit </button></td>
                  <td><button type="button" class="btn btn-outline-danger btn-sm" onClick={() => setConfirmDialog({
                        isOpen: true,
                        title: 'Are you sure to delete this record?',
                        subTitle: "You can't undo this operation",
                        onConfirm: () => {handleDelete(delete_id=leaveType.leave_type_id)}
                      })}
                  > <Delete/> Delete </button></td>
                  <td>{leaveType.leave_type}</td>
                  <td>{leaveType.entitled_days}</td>
                  <td>{leaveType.max_occasions}</td>
                  <td>{leaveType.max_days}</td>
                  <td>{leaveType.paid_unpaid}</td>
                  <td>{leaveType.prefix_suffix}</td>
                  <td>{leaveType.entitled_days_duration}</td>
                  <td>{leaveType.cary_forward}</td>
                  <td>{formatDate(leaveType.leave_year_from)}</td>
                  <td>{formatDate(leaveType.leave_year_to)}</td>
                  <td>{leaveType.company_id}</td>
                  <td>{leaveType.leave_encashable}</td>
                  <td>{leaveType.encash_basedOn}</td>
                </tr>
            </>
          )
        })}

        </tbody>
      </table>
      <Popup
      title="Edit Leave Type"
      openPopup={openPopup}
      setOpenPopup={setOpenPopup}
      >
        <LeaveMasterForm
          fetch_id={fetch_id}
        />
      </Popup>

      <Notification
        notify={notify}
        setNotify={setNotify} 
      />
      <ConfirmDialog
        confirmDialog={confirmDialog}
        setConfirmDialog={setConfirmDialog} 
      />

    </div>

  );
}
